import { connect } from 'react-redux';
import View from './MonthlyBenefitsView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import {
  principalNameSelector,
  partnerNameSelector,
  hasPartnerSelector,
  fileForSurvivorBenefitsSelector,
  useSpousalBenefitSelector,
  amountSpouseSelector,
  amountPrincipalSelector,
  selectSocialSecurityCurrentlyReceivingBenefitsPrincipal,
  selectSocialSecurityCurrentlyReceivingBenefitsSpouse,
  selectSocialSecurityIncomeFrequencySpouse,
  selectSocialSecurityIncomeFrequencyPrincipal,
  selectPrincipalIsCurrentlyReceivingBenefitsUnderCurrentPlan,
  selectSpouseIsCurrentlyReceivingBenefitsUnderCurrentPlan,
  selectPrincipalAgeOptions,
  selectSpouseAgeOptions,
  selectPrincipalAge,
  selectSpouseAge,
  selectPrincipalIsFRA,
  selectSpouseIsFRA,
} from './MonthlyBenefitsSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
} from '../../WhatIfsActions';
import {
  optimizeSocialSecurity,
  applyOptimalSocialSecuritySolution,
} from './MonthlyBenefitsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';
import { isCurrentPlanSelector } from '../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  principalName: principalNameSelector(state, ownProps),
  partnerName: partnerNameSelector(state, ownProps),
  hasPartner: hasPartnerSelector(state, ownProps),
  principalSelectedAge: selectPrincipalAge(state),
  spouseSelectedAge: selectSpouseAge(state, ownProps),
  fileForSurvivorBenefits: fileForSurvivorBenefitsSelector(state, ownProps),
  useSpousalBenefit: useSpousalBenefitSelector(state, ownProps),
  amountSpouse: amountSpouseSelector(state, ownProps),
  amountPrincipal: amountPrincipalSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
  socialSecurityCurrentlyReceivingBenefitsPrincipal: selectSocialSecurityCurrentlyReceivingBenefitsPrincipal(
    state,
    ownProps,
  ),
  socialSecurityCurrentlyReceivingBenefitsPartner: selectSocialSecurityCurrentlyReceivingBenefitsSpouse(
    state,
    ownProps,
  ),
  socialSecurityIncomeFrequencyPrincipal: selectSocialSecurityIncomeFrequencyPrincipal(
    state,
    ownProps,
  ),
  socialSecurityIncomeFrequencySpouse: selectSocialSecurityIncomeFrequencySpouse(state, ownProps),
  principalIsCurrentlyReceivingBenefitsUnderCurrentPlan: selectPrincipalIsCurrentlyReceivingBenefitsUnderCurrentPlan(
    state,
    ownProps,
  ),
  spouseIsCurrentlyReceivingBenefitsUnderCurrentPlan: selectSpouseIsCurrentlyReceivingBenefitsUnderCurrentPlan(
    state,
    ownProps,
  ),

  principalAgeOptions: selectPrincipalAgeOptions(state, ownProps),
  spouseAgeOptions: selectSpouseAgeOptions(state, ownProps),
  principalIsFRA: selectPrincipalIsFRA(state, ownProps),
  spouseIsFRA: selectSpouseIsFRA(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate, mode) => () => {
    dispatch((innerDispatch, getState) => {
      const isCurrentPlan = isCurrentPlanSelector(getState(), { clientId });

      // Optimizer apply re-runs the optimizer against the persisted plan and rejects
      // Current Plan. Use that path only after Maximize on Proposed Plan; otherwise
      // persist the form values already shown in the What-If.
      if (mode != null && !isCurrentPlan) {
        innerDispatch(
          applyOptimalSocialSecuritySolution(
            mode,
            clientId,
            fpId,
            goalId,
            whatIfTemplate.WhatIfType,
          ),
        );
        return;
      }

      innerDispatch(
        applyWhatIf(
          clientId,
          fpId,
          goalId,
          whatIf,
          RouteDictionary[whatIfTemplate.WhatIfType],
          Object.keys(whatIfTemplate),
          whatIfTemplate.WhatIfType,
        ),
      );
    });
  },
  optimizeSocialSecurity: (mode, clientId, fpId, goalId, whatIfType) => {
    dispatch(optimizeSocialSecurity(mode, clientId, fpId, goalId, whatIfType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
